module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-column flex-1"
  }, [_c('u-header', {
    attrs: {
      "show-back": !_vm.editingMode,
      "prevent-back": !!_vm.selection
    },
    on: {
      "back": function($event) {
        _vm.$emit('back')
      }
    }
  }, [(_vm.editingMode) ? _c('span', {
    staticClass: "gift icon-cross",
    attrs: {
      "slot": "left"
    },
    on: {
      "click": _vm.cancel
    },
    slot: "left"
  }) : _vm._e(), _vm._v(" "), (_vm.selection) ? _c('span', {
    on: {
      "click": _vm.add
    }
  }, [_c('span', {
    staticClass: "gift icon-plus"
  }, [_vm._v(" 添加" + _vm._s(_vm.title))])]) : _c('span', [_vm._v(_vm._s(_vm.isMultiRemoving ? '批量删除' : _vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-1 flex-between",
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [(!_vm.selection && !_vm.editingMode && _vm.data.length) ? _c('span', {
    staticClass: "gift icon-multi",
    on: {
      "click": _vm.multiRemove
    }
  }) : _c('span', [_vm._v(" ")]), _vm._v(" "), (_vm.selection || _vm.editingMode) ? _c('span', {
    staticClass: "gift icon-zhengque",
    on: {
      "click": _vm.save
    }
  }) : _c('span', {
    staticClass: "gift icon-plus",
    on: {
      "click": _vm.add
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "scrollable flex-1"
  }, [(!_vm.data.length && !_vm.isAdding) ? _vm._t("default") : _vm._e(), _vm._v(" "), (_vm.isAdding) ? _c('div', {
    staticClass: "row flex flex-column checked"
  }, [_c('div', {
    staticClass: "left flex flex-1 flex-cross-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newName),
      expression: "newName"
    }],
    ref: "input",
    staticClass: "editing-name",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newName = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.sortedList), function(item, index) {
    return _c('div', {
      directives: [{
        name: "longpress",
        rawName: "v-longpress",
        value: (function () {
          _vm.multiRemove();
          _vm.checkedList = [index]
        }),
        expression: "()=>{multiRemove();checkedList=[index]}"
      }],
      key: item.id,
      staticClass: "row flex flex-cross-center flex-between",
      class: {
        checked: _vm.checkedList.indexOf(index) > -1
      },
      on: {
        "click": function($event) {
          _vm.toggleChecked(index)
        }
      }
    }, [_c('div', {
      staticClass: "left flex-inline flex-cross-center"
    }, [(_vm.isMultiRemoving || _vm.selection) ? _c('span', {
      staticClass: "checkbox"
    }) : _vm._e(), _vm._v(" "), (_vm.editingIndex === index) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newName),
        expression: "newName"
      }],
      ref: "input",
      refInFor: true,
      staticClass: "editing-name",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.newName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.newName = $event.target.value
        }
      }
    }) : _c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), (!_vm.isMultiRemoving && (_vm.editingIndex === -1 || index !== _vm.editingIndex)) ? _c('div', {
      staticClass: "btn-list flex-inline flex-cross-center"
    }, [_c('span', {
      staticClass: "gift icon-edit",
      on: {
        "click": function($event) {
          _vm.edit(item, index)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "gift icon-lajixiang",
      on: {
        "click": function($event) {
          _vm.remove(item, index)
        }
      }
    })]) : _vm._e()])
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fbbf522","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ListManage.vue
// module id = 179
// module chunks = 1 2